import { styled } from '@mui/material/styles';
import {
  Select as MuiSelect,
  SelectProps as MuiSelectProps,
  InputLabel as MuiInputLabel,
  MenuItem as MuiMenuItem,
  Typography as MuiTypography,
  Typography,
} from "@mui/material";

export const SelectFieldContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  gap: theme.space._200,
}));

export const IconBox = styled("span")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const InfoMessageContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  alignSelf: 'stretch',
  padding: `0 ${theme.space._500} ${theme.space._100} ${theme.space._500}`,
  gap: theme.space._300,
  
  color: theme.colors['yellow.300'],
}));

export const InfoTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontWeight: theme.fontWeights.medium,
  lineHeight: theme.lineHeights.base,
}));

export const CustomMenuItem = styled(MuiMenuItem)(({ theme }) => ({
  padding: `${theme.space._200} ${theme.space._500} `,
  
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.md,
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.base,
  color: theme.colors["neutral.200"],
}));

export const CustomInputLabel = styled(MuiInputLabel)(({ theme }) => ({
  color: theme.colors["neutral.200"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.base,

  transform: 'translate(0, 0) scale(1)',
}));

export const CustomSelectField = styled(MuiSelect)<MuiSelectProps>(({ theme }) => ({
  cursor: "pointer",
  '& .MuiInputBase-input': {
    color: theme.colors["neutral.200"],
    fontFamily: theme.fonts.default,
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.medium,
    lineHeight: theme.lineHeights.base,
    height: "20px",
    borderRadius: "8px",
    '&.Mui-disabled': {
      WebkitTextFillColor: theme.colors["neutral.200"],
    },
  },

  "&:hover .MuiOutlinedInput-notchedOutline": {
    border:`1.5px solid ${theme.colors["neutral.500"]}` ,
  },

  '& .Mui-disabled': {
    cursor: "not-allowed",
    pointerEvents: "auto",
    opacity: theme.opacity.intense,

    "svg": {
      color: theme.colors["neutral.600"]
    }
  },

  '& .MuiSelect-icon': {
    color: theme.colors["neutral.200"],
    right: theme.space._300,
    top: 0,
    bottom: 0,
    margin: "auto",
  },

  '& .MuiInputBase-root': {
    color: theme.colors["neutral.200"],
    '& fieldset': {
      borderRadius: "8px",

    },
    '&:hover fieldset': {
      borderColor: theme.colors["neutral.200"],
      borderRadius: "8px",
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.colors['blue.400'],
      borderRadius: "8px",
    }
  },

  '&.is-error.MuiInputBase-root': {
    '& fieldset': {
      borderColor: theme.colors["red.700"],
    },
    '&:hover fieldset': {
      borderColor: theme.colors["red.600"],
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.colors["red.700"],
    },
  }
}));

export const ErrorMessageTypography = styled(Typography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontStyle: "normal",
  fontWeight: theme.fontWeights.medium,
  lineHeight: theme.lineHeights.base,
  color: theme.colors["red.500"],
}));